const emailValidator = (email: string) => {
    const req = /^\S+@\S+$/;
    if (req.test(email)) {
        return true;
    }

    return "Niepoprawny adres e-mail";
};

export default emailValidator;
